import React, { Fragment } from 'react';
import './Styles.css';

const Checkbox = (props) => {
    return <Fragment>
        <div className="checkBoxContainer">
            <input type={props.type} id={props.id} name={props.name} value={props.value} onChange={props.onClick} checked={props.checked}/>
            <label htmlFor={props.for}>{props.label}</label>
        </div>
    </Fragment>
}
export default Checkbox;